import styled from "styled-components";

export const Container = styled.div`
  gap: 8px;
  padding: 120px 20px 20px 20px;
  display: flex;
  background-color: #f5f5f5;
`;
